module.exports =  {
    common:{
        csApp:'长桑健康',
        laiKangApp:'徕菲运动健康',
        deleteAccountTip1:'1.APPでアカウントを削除するか、本Webサイトで削除するか、削除後にログインできません。',
        deleteAccountTip2:'2.ユーザーデータは削除されません。アカウントデータを削除するには、ユーザーがカスタマーサービス電話を通じてデータを照合する必要です。',
        account:'アカウント',
        password:'パスワード',
        deleteAccount:'アカウントの削除',
        accountValid:'アカウントの入力が正しいかを確認してください',
        passwordValid:'パスワードの入力が正しいかを確認してください',
        accountAndPasswordValid:'アカウントまたはパスワードの入力が正しいかを確認してください',
        deleteAccountSuccess:'アカウントの削除に成功しました',
        deleteAccountFail:'アカウントの削除に失敗しました',
        date:'日付',
        time:'時間',
        hour:"時",
        min:"分",
        second:"秒",
        day:"日",
        week:"週間",
        month:"月",
        year:"年",
        dayUnit:"日",
        weekUnit:"週間",
        monthUnit:"月",
        yearUnit:"年",
        detail:"詳細",
        percent:"パーセント",
        percentUnit:"%",
        maxValue:'最大値',
        minValue:'最小値',
        highest:"最高",
        minimum:"最低",
        normal:"通常",
        abnormal:"異常",
        normalPercent:"通常の割合",
        abnormalPercent:"異常の割合",
        numUnit:"次",
        to:"至",
        formatDateYMD:"YYYY年MM月DD日",
        formatDateMD:"MM月DD日",
        formatDateYM:"YYYY年MM月",
        formatDateM:"MM月",
        formatDateYMDHM:"YYYY年MM月DD日 HH:mm",
        formatDateYMDHMS:"YYYY年MM月DD日 HH:mm:ss",
        formatDateMDHMS:"MM月DD日 HH:mm:ss",
        tip:"ヒント",
        confirm:"確認",
        cancel:"キャンセル",
        noData:"しばらくデータなし",
        allDataLoadComplete:"完全なデータをロードしました",
        waiting:"少々お待ちください",
        contentLoading:"コンテンツロード中",
        noContainData:"関連コンテンツはありません",
        noNetwork:"ネットワークがない",
        nowLoadingMoreData:"より多くのデータをロードしています。少々お待ちください",
        monday: '月曜日',
        tuesday: '火曜日',
        wednesday: '水曜日',
        thursday: '木曜日',
        friday: '金曜日',
        saturday: '土曜日',
        sunday: '日曜日',
        showAll:'すべて表示',
        packUp:'閉じる',
        showAllMore:'もっと表示',
        packUpMore:'もっと収める',
        target:'ターゲット',
        dontReachStandard:'未達',
        reachStandard:'達成',
        totalDayNum:'総日数',
        referenceValue:'参照値',    
        month1:'1月',
        month2:'2月',
        month3:'3月',
        month4:'4月',
        month5:'5月',
        month6:'6月',
        month7:'7月',
        month8:'8月',
        month9:'9月',
        month10:'10月',
        month11:'11月',
        month12:'12月',
        month1_long:'1月',
        month2_long:'2月',
        month3_long:'3月',
        month4_long:'4月',
        month5_long:'5月',
        month6_long:'6月',
        month7_long:'7月',
        month8_long:'8月',
        month9_long:'9月',
        month10_long:'10月',
        month11_long:'11月',
        month12_long:'12月', 
        peleaseSelect:'選択してください',
 
        average:'平均',
        numMinUnit:'次/分',
        
        
    },
    sport:{
        sport:'スポーツ',
        sportReport:'スポーツレポート',
        sportHrSet:'運動心拍数設定',

        sportType1:'アウトドアランニング',
        sportType2:'室内ランニング',
        sportType3:'アウトドアウォーキング',
        sportType4:'室内ウォーキング',
        sportType5:'アウトドアライド',
        sportType6:'室内ライド',
        sportType7:'プールで泳ぐ',
        sportType8:'開放水域',
        sportType9:'登山',
        sportType10:'徒歩',
        sportType11:'クロスカントリー',
        sportType12:'ゴルフ練習',
        sportType13:'スキー',
        sportType14:'スノーボード',
        sportType15:'クロスカントリースキー',
        sportType16:'トライアスロン',
        sportType17:'楕円機',
        sportType18:'ボートを漕ぐ',
        sportType19:'縄跳び',
        sportType20:'バドミントン',
        sportType21:'ピンポ',
        sportType22:'テニス',
        sportType23:'バスケットボール',
        sportType24:'サッカー',
        sportType25:'野球',
        sportType26:'バレーボール',
        sportType27:'クリケット',
        sportType28:'ラグビー',
        sportType29:'ホッケー',
        sportType30:'ダンス',
        sportType31:'動感単車',
        sportType32:'ヨガ',
        sportType33:'仰向けに寝て座る',
        sportType34:'体操',
        sportType35:'開閉ジャンプ',

        consume:'消費',
        Pacing:'配速',
        Kilocalorie:'キロカロリー',
        kilometre:'キロ',

        sportStatistics:'活動統計',
        distanceAndUnit:'距離（キロ）',
        distance:'距離',
        consumeAvg:'消費（キロカロリー）',
        pacingAvg:'平均配速（/キロ）',
        cadenceAvg:'平均ステップ周波数（ステップ／分）',
        timeNum:'時間',
        totalStepNum:'合計ステップ数',

        step:'ステップ',
        stepReport:'ステップ数レポート',
        stepUnit:'ステップ',
        stepAvg:'平均ステップ数',
        
        stepconsume:'消費に相当する',
        stepStatistics:'歩数統計',
        eggNum:'卵',
       
        stepDistance:'行ったことに相当する',
        stepDistanceNum:'圏標準運動場',
        
        
    },
    sleep:{  
        sleep:'睡眠',
        sleepTime:'睡眠時間が長い',
        deepSleep:'深い眠り',
        lightSleep:'浅い眠り',
        eyeMovement:'目が動く',
        eyeMovementFast:'クイックアイラッシュ',
        sober:'はっきりしている',

        deepSleepAvg:'平均深寝',
        lightSleepAvg:'平均浅寝',
        eyeMovementFastAvg:'平均高速眼動',

        sleepStatistics:'睡眠統計',
        sleepNight:'夜間睡眠',
        sleepNightAvg:'平均夜間睡眠',
        deepSleepRate:'深い眠りの割合',
        deepSleepRateAvg:'平均深寝の割合',
        lightSleepRate:'浅い眠りの割合',
        lightSleepRateAvg:'平均浅寝の割合',
        eyeMovementFastRate:'高速眼動スケール',
        eyeMovementFastRateAvg:'平均高速眼動スケール',
        soberNumber:'覚醒回数',
        soberNumberAvg:'平均覚醒回数',

        sleepBeginTimeAvg:'平均入眠時間',
        sleepEndTimeAvg:'平均起床時間',
        
    },
    measure:{
        bloodOxygenTitle:"酸素血中報告",
        bloodOxygen:"血中酸素",
        bloodOxygenPercent:"血中酸素状態占有率",
        bloodOxygenSaturation:"酸素飽和度",
        bloodOxygenSaturationTip1:"運動は血液循環を促進し、酸素レベルを高める最善の方法であり、もし自分に呼吸器系疾患があれば、選択すべきだ",
        bloodOxygenSaturationTip2:"緩やかな運動を選び、順を追って酸素飽和度を高めていく。",
        fingertip:"指先",
        wrist:"手首",
        fingertipBloodOxygenList:"指先の酸素リスト",
        wristBloodOxygenList:"手首酸素リスト",
        bloodOxygenList:"血中酸素リスト",
        
        bloodPressure:'血圧',
        bloodPressureDetail:'血圧詳細',
        bloodPressureSys:'収縮圧',
        bloodPressureDia:'拡張圧力',
        mmHg:'ミリ水銀柱',
        measurementStatistics:'測定統計',
        measurementsTotalNumber:'総測定回数',
        measurementsNumber:'測定回数',
        bloodPressureMeasureTip1:'朝（6：00〜：8：00治療中の者は服薬前）、午後（17：00〜19：00）、夜（就寝前20：00〜24：00）に1回ずつ監視',
        bloodPressureMeasureTip2:'測定前に5分間静座して休憩し、血圧測定ごとに2回、2回の間に1 min間隔を測定する必要がある；',
        bloodPressureGoToMeasure:"すぐに測定する",
        measurementsReachStandardDayNum:'測定達成日数',
        bloodPressureStatus:'血圧状態',
        bloodPressureNormalNum:'正常血圧回数',
        bloodPressureNormalHighNum:'正常高血圧回数',
        bloodPressureHighLevelOneNum:'1級高血圧測定回数',
        bloodPressureHighLevelTwoNum:'2級高血圧測定回数',
        bloodPressureStatistics:'血圧統計',
        bloodPressureAverage:'血圧平均値',
        bloodPressureLoadValue:'血圧負荷値',
        bloodPressureAvgSys:'平均収縮圧',
        bloodPressureAvgDia:'平均拡張圧',
        bloodPressureDaySys:'日中収縮圧',
        bloodPressureDayDia:'日中拡張圧',
        bloodPressureNightSys:'夜間収縮圧',
        bloodPressureNightDia:'夜間拡張圧',
        bloodPressureNightDropRate:'夜間血圧降下率',
        bloodPressureMeanArterialPressureAll:'平均（動脈）圧［MAP］',
        bloodPressureMeanArterialPressure:'平均動脈圧',
        bloodPressureCoefficientVariation:'血圧変異係数（CV）',
        measureTime:'測定時間',
        measureBeginTime:'開始時間',
        measureEndTime:'終了時間',
        bloodPressureIndicators:'血圧指標',
        keepHealthAwayNibpTip:'塩の摂取量を減らす、食事のバランスをとるアルコールの有害な使用を避ける、よく運動するタバコの使用を避けることができます。',
        bloodPressureNormal:'正常血圧',
        bloodPressureNormalHigh:'正常高血圧',
        bloodPressureHighLevelOne:'1級高血圧',
        bloodPressureHighLevelTwo:'2級高血圧',
        bloodPressureProtectAdvice:'血圧保護提案',
        bloodPressureMeasureAdvice:'血圧測定推奨',
        day_avager:'日平均',  
        bloodPressureReport:'血圧報告',
        bloodPressureReportExplain:'血圧報告解析',
        bloodPressureReachDetail:'目標達成詳細',
        explainDoctor:'解読医師',
        evaluate:'評価',
        reportProductSuccessTip:'レポート生成のリマインダ方法',
        messageTip:'SMSリマインダ',
        reportProductIng:'レポートはまだ解析中です',
        diagnosisApply:'診断申請',
        reportProductNeedTime:'解析レポートは1～2時間かかる',
        reprotDayReachStandard:'日達成規則：当日6：00 ~ 8：00、17:00~19:00；20:00 ~ 24:00に目標測定回数(時間帯ごとに2回)を達成した。',
        reprotWeekReachStandard:'週間達成規則：歴史7日、毎日3回の測定を達成すれば週間達成。',
        
        reprotReachStandardAdvice1:'今日から3日間お願いします。',
        reprotReachStandardAdvice2:'の06:00 ~ 08:00、17:00 ~ 19:00、20:00 ~ 24:00各2回の血圧測定を行い、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reprotReachStandardAdvice3:'今日と明日の06:00 ~ 08:00、17:00 ~ 19:00、20:00 ~ 24:00に2回ずつ血圧測定を行って、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reprotReachStandardAdvice4:'今日の17:00 ~ 19:00、20:00 ~ 24:00に血圧測定を2回ずつ行って、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reprotReachStandardAdvice5:'今日の20：00～24：00に2回ずつ血圧測定を行って、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reprotReachStandardAdvice6:'本日の06:00 ~ 08:00、17:00 ~ 19:00、20:00 ~ 24:00に2回ずつ血圧測定を行って、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reprotReachStandardAdvice7:'明日から3日間お願いします',
        reprotReachStandardAdvice8:'明日から2日間お願いします',
        reprotReachStandardAdvice9:' 明日の06:00 ~ 08:00、17:00 ~ 19:00、20:00 ~ 24:00に2回ずつ血圧測定を行って、今週の測定回数が基準に達成すればレポートを生成することができます。',
        reportductIng:'生成中',
        readed:'既読',
        unread:'未読',

        suanHuaGuideTip1:'血圧の学びと測定方法',
        suanHuaGuideTip2:'心壁血圧機能の学びと測定における注意事項',
        suanHuaGuideTip3:'血圧の学び方法',
        suanHuaGuideTip4:'血圧を迅速に了解し、精確な血圧測定をオンにする',
        suanHuaGuideTip5:'腕時計の血圧機能の学びと測定における注意事項',
        suanHuaGuideTip6:'APPで文字盤を交換する方法',
        suanHuaGuideTip7:'文字盤をすばやく了解し、複数の文字盤を開き、毎日交換する',
        
        
        heartRate:'心拍数',
        heartRateTitle:'心拍数報告',
        heartRateAvg:'平均心拍数',
        fingertipheartRateList:"指先心拍数リスト",
        wristheartRateList:"手首心拍数リスト",
        heartRateList:"心拍数リスト",

        pressurePressureIndex:'圧力指数',
        pressureTired:'疲労度',
        pressureSpirePressure:'精神的ストレス',
        pressureTolerance:'ストレス耐性',
        pressureTitle:'圧力レポート',
        good:     '良好',
        notBad:   '尚好',
        Moderate: '中程度',
        poor:     '劣っている',
        easy:     '楽',
        tired:    '疲れている',
        fatigue:  '疲労',
        low:      '低',
        medium:   '中',
        high:     '高',
        veryHigh: 'とても高い',
        lightHigh:'高すぎる',
        lightLow:'低すぎる',
        fast:'やや速い',
        lightFast:'少し速く',
        lightSlow:'遅い',
        
        
        temperature:'体温',
        temperatureReport:'体温レポート',
        temperatureIndicators:'体温指標',
        
        measureDetailTip1Title:'測定前準備',
        measureDetailTip10:'**診察室で血圧を測定するには、適切な空間、適切な温度（≒72°F／22℃）、静かで騒音のない環境でなければならない。被験者に関連する多くの要素は、室内温度、運動、飲酒または喫煙、腕の位置、筋肉緊張、膀胱充満、談話、環境騒音などの血圧測定の偏差を引き起こすことができる。被験者の話は一般的な要素であるため、ストレス測定時に被験者は話をしないでください。医療関係者も被験者と話をすることはできません。',
        measureDetailTip11:'1.患者にリラックスさせ、椅子に座り、両足を地面に平らに置いて椅子の背に寄りかかり、太ももを重ねてはならないように指示した。最初の測定前に、5分以上座って、会話や移動をしないでください。',
        measureDetailTip12:'2.測定を開始する少なくとも30分前に、運動、喫煙、コーヒーを飲むことを避けてください。',
        measureDetailTip13:'3.患者が膀胱を空にすることを確保します。',
        measureDetailTip14:'4.血圧を測定する過程で、患者や医療関係者は口をきかないでください。。',
        measureDetailTip15:'5.カフ部を覆う服を脱ぎ、上腕を十分に露出し、袖を巻くべきではなく、止血帯効果が生じる可能性があるからです。',
        measureDetailTip2Title:'適切なデバイスを選択し、正しい測定方法を取ってください。',
        measureDetailTip21:'1.計量基準を満たす水銀柱血圧計、または（ESH、BHS、AAMI）検証を経た上腕式電子血圧計を選択し、血圧計の定期的な校正を確保します。',
        measureDetailTip22:'2.測定者は座席を取り、背もたれ椅子に座ったほうがいい、右上腕を露出し、肘を心臓と同じレベルに置き、被験者の腕は自然に机の上に置き、拳を握らないでください。筋肉の動作は血圧レベルに影響を与えるからです。',
        measureDetailTip23:'3.血圧計は心臓レベルに置くべきです。カフの中央部は患者の上腕部に置かれ、右心房と水平に並び、胸骨中点に相当します。',
        measureDetailTip24:'4.カフを縛る：測定者はまず患者の肘窩にある上腕動脈に手を当て、カフエアバッグの長軸中心（通常は製造商標によってカフに記載されている）を上腕を露出した動脈拍動の上に置いでてください。カフの下端は肘窩の上方から2 ~ 3センチ離れ、聴診頭を置く空間を残し、位置は心臓（乳頭レベル）と同じ水平線上にあり、カフの緊張度は1-2本の指を収容できるようにするのが望ましいです。',
        measureDetailTip25:'5.適切な大きさのエアバッグカフを使用し、適切な大きさのカフ、例えばエアバッグを使用して上腕の75%~ 100%を取り囲む。肥満者や腕周りが大きい者は大規格エアバッグカフを使用し、子供は小規格エアバッグカフを使用しなければなりません。',
        measureDetailTip26:'6..水銀血圧計時を用いて聴診器のプローブを肘窩上腕動脈拍動所に置き、カフ内に置いてはなりません。',
        measureDetailTip3Title:'聴診法（水銀血圧計）測定規範',
        measureDetailTip31:'1.水銀血圧計を用いて測定する場合、測定者の視線は血圧計の文字盤とレベルを維持し、等速で空気を入れ、エアバッグ内の圧力は上腕動脈の拍動が消失し、さらに30 mmHg上昇し、その後、一定の速度（2-6 mmHg/S）でゆっくりと空気を抜くべきです。心拍数が遅い場合は排気速度も遅いです。拡張圧の示度を取得した後、急速にゼロに空気を放出します。',
        measureDetailTip32:'2.ガス抜き中にコーステナイト音をよく聞き、コーステナイト音の第I時相と第V時相水銀柱凸面の垂直高さを観察します。収縮圧示度はコーステナイト音の第I時相（第1音）をとり、拡張圧示度はコーステナイト音の第V時相（消失音）を取ります。',
        measureDetailTip33:'3.すべての示度は水銀凸面の先端を基準としなければなりません。読取りは偶数（0、2、4、6、8）をとるべきです。電子血圧計は血圧データの表示に準拠しています。',
        measureDetailTip34:'4.少なくとも2回測定し、1分おきに繰り返し測定し、隣接2回の収縮圧または拡張圧の示度が5 mmhg未満であれば、2回の平均値をとり、5 mmhgより大きければ、3回目を測定し、3回の平均値を取ります。血圧値を読み取る場合、末尾桁は偶数にしかなりません。',
        measureDetailTip4Title:'血圧測定頻度',
        measureDetailTip401:'2019中国家庭血圧監視ガイドライン',
        measureDetailTip402:'家庭血圧モニタリングする場合は、…べきです。',
        measureDetailTip403:'毎日朝、夜',
        measureDetailTip404:'血圧を測定する',
        measureDetailTip41:'1.測定ごとに座位で5 min休憩した後、2〜3回測定し、1 min間隔で行います。',
        measureDetailTip42:'2.初診患者、早期或いは治療を受けたが、血圧がまだ基準を満たしていない患者を治療するには、診察前に5〜7日連続測定しなければなりません；血压',
        measureDetailTip43:'3.制御が良好な場合、毎週少なくとも1 dを測定します。',
        measureDetailTip44:'4.朝の血圧測定は起床後1時間以内に行うべきで、降圧薬を服用する前、朝食前、激しい活動前。夜間血圧測定は夕食後、ベッドに入る前に行われます。',
        measureDetailTip45:'5.朝、夜を問わず、血圧を測定する前に膀胱を空にすることに注意しなければなりません。',
        measureDetailTip46:'6.家庭血圧モニタリングの品質を確保するために、血圧モニタリング期間は起床時間、就寝時間、三食時間及び服薬時間を記録しなければなりません。',
        measureDetailTip5Title:'血圧の生理的変化',
        measureDetailTip51:'1.年齢：加齢とともに拡張圧と収縮圧は徐々に上昇する傾向にあります。',
        measureDetailTip52:'2..性別：女性、更年期前に、男性より低く、更年期後に、血圧が上昇し、差が小さいです。',
        measureDetailTip53:'3.環境：寒い環境、血圧はやや上昇している、高温環境では、血圧が少し下がることがあります。',
        measureDetailTip54:'4.昼夜と睡眠：通常午前6 ~ 10時にピークに達し、午後14:00 ~ 15:00に低下し、16:00 ~ 18:00にまたピークに達し、以降はゆっくりと午前2 ~ 3時の最低谷値まで低下した。休みや睡眠が悪いときは、血圧が少し高くなります。',
        measureDetailTip50:'* 血圧変動も測定された姿勢、室内温度、喫煙、飲酒、腕の位置、運動、談話及び外部環境騒音などの要素と関係があり、規定に従って穏やかな状態で測定する必要があります。',
        measureDetailTip6Title:'異なる測定方法の高血圧診断基準',
        measureDetailTip7Title:'血圧示度に影響するいくつかの大きな誤差',
        measureDetailTip71:'1.膀胱充満：すなわち尿を止めると、血圧示度が約10 ~ 15 mmHg高くなる可能性があります。血圧を測定する前に、膀胱を空にしなければなりません。',
        measureDetailTip72:'2.座り方が正しくない：怠惰、背中或いは下肢の支持不足などの情況を含み、血圧の示度が約6 ~ 10 mmHg高くなる可能性があります。血圧を測定するときは、椅子の背に背を向け、足を床や足のベンチに平らに置く必要があります。',
        measureDetailTip73:'3.腕の宙に浮いています：血圧示度が約10 mmHg高くなる可能性があります。血圧を測定するときは、腕をテーブルの上に平らに置き、測定カフのレベルを心臓と平らにしなければなりません。',
        measureDetailTip74:'4.カフを服にかぶせます：血圧示度が約5 ~ 50 mmHg高くなる可能性があります。血圧を測定する時、隔衣の厚さは1 mm（薄いシャツなど）未満で、腕を露出できることが望ましいです。',
        measureDetailTip75:'5.カフが小さすぎてきつすぎます：血圧示度が約2 ~ 10 mmHg高くなる可能性があります。適切なサイズのカフスを選択してください。',
        measureDetailTip76:'6.反り：血圧示度を約2 ~ 8 mmHg高くする可能性がある。血圧を測定するときは足を上げないで、両足を平らにして支えてください。',
        measureDetailTip77:'7.談話：血圧測定時の被験者の質問、質問への回答、電話などの現象により、血圧示度が約10 mmHg高くなる可能性があります。血圧を測るときは、話さないように注意して、静かにしてください。',
        measureDetailTip8Title:'体位別血圧測定差',
        measureDetailTip81:'血圧は坐位、臥位、立位などの姿勢で測定することができますが、これまで高血圧の診断と治療は坐位血圧を根拠としていたため、各ガイドラインでは',
        measureDetailTip82:'高血圧患者の日常血圧測定は座位で行うことを推奨します。座位測定が不便な患者には、横になって血圧測定を行うことができます。',
        measureDetailTip83:'測定過程が規範化されていれば、どの姿勢測定がより正確であるかは関係なく、異なる姿勢や体位下の人体血圧を反映しています。',
        measureDetailTip84:'座位法血圧値は臥位法より約3 mmHg低下しました、立位測定は座位より約5 mmHg低下し、臥位より8 mmHg低下しました。',
        measureDetailTip85:'すなわち臥位＞座位＞立位。',
        measureDetailTip86:'以上の違いはすべて統計学的に有意です。',
    }
}